import Reactotron from 'reactotron-react-js'
import { reactotronRedux } from 'reactotron-redux'

const reactotron = Reactotron
    .configure({ name: 'Alumni WebApp 2' })
    .use(reactotronRedux())
    .connect() // let's connect!

export default reactotron
